import { useEffect } from 'react';
export var useActiveCardDetection = function useActiveCardDetection(_ref) {
  var containerRef = _ref.containerRef,
    isMobile = _ref.isMobile,
    setActiveIndex = _ref.setActiveIndex;
  useEffect(function () {
    var container = containerRef.current;
    if (!container || !isMobile) return;
    var handleScroll = function handleScroll() {
      var cards = container.querySelectorAll("[data-card]");
      var closestIndex = 0;
      var minDistance = Infinity;
      cards.forEach(function (card, index) {
        var rect = card.getBoundingClientRect();
        var containerRect = container.getBoundingClientRect();
        var cardCenter = rect.left + rect.width / 2;
        var containerCenter = containerRect.left + containerRect.width / 2;
        var distance = Math.abs(containerCenter - cardCenter);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });
      setActiveIndex(closestIndex);
    };
    container.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll(); // initialize
    return function () {
      return container.removeEventListener("scroll", handleScroll);
    };
  }, [containerRef, isMobile, setActiveIndex]);
};